import React, { useState, useEffect } from "react";
import { useAssetContext } from "../../DataContext/AssetContext";
import EstimatedRevenueDropdown from "./EstimatedRevenueDropdown";
import { FaRegFilePdf } from "react-icons/fa6";
import { TbFileExcel } from "react-icons/tb";
import { FaRegCopy } from "react-icons/fa";
import { BsFiletypeCsv } from "react-icons/bs";
import { exportTableToPDF, useExportLogo } from "../ConfigCharts/ExcelCurved";
import { exportTableOldToExcel } from "../ConfigCharts/ExcelCurved";
import { exportToCSV } from "../ConfigCharts/ExportUtils";
import WindmillLoading from "../../Loading/Loading";
import ApiErrorMessage from "./ApiErrorMessage"; 
import { DateTime } from "luxon";
interface TableData {
  hourEnding: string;
  [key: string]: any;
}

interface Resource {
  RESOURCE_ID: string;
  RESOURCE_NAME: string;
  [key: string]: any;
}
interface ResourceWrapper {
  RESOURCES: Resource[];
  
}
interface RevenueTableProps {
  title?: string;
}
const Table: React.FC<RevenueTableProps> = ({ title }) => {
  const {
    revenueAsset,
    revenueMetrics,
    VolumeDeltaAsset,
    groupedVolumeDataAsset,
    groupedPricingAsset,
    selectedResource,
    setSelectedResource,
    selectedFrequency,
    selectedDateRange,
    selectedRevenue,
    resourceNames,
    GroupByrevenueMetrics,
    useIntervalAggregation,
    isLoading,
    apiError,
    isDeltaLoading,
    DeltaApiError,
    GroupByVolumeDeltaMetrics
  } = useAssetContext();

  const [data, setData] = useState<TableData[]>([]);
  const { selectedMeasures } = useAssetContext();

  useEffect(() => {
  }, [selectedMeasures]);
  

  let activeMetrics: string[] = [];

  const fallbackMetrics = ["DAM", "FMM", "RTM"];
  const volumeDeltaMetricsFiltered = GroupByVolumeDeltaMetrics?.filter(metric => metric !== "METERED_OUTPUT") || [];
  const groupMetrics = GroupByrevenueMetrics?.length
    ? GroupByrevenueMetrics
    : volumeDeltaMetricsFiltered.length
      ? volumeDeltaMetricsFiltered
      : fallbackMetrics;

  if (
    selectedRevenue === "market_type" ||
    selectedRevenue === "product" ||
    selectedRevenue === "award_type" ||
    selectedRevenue === "settlement_charge_name"||
    selectedRevenue === "total"
  ) {
    activeMetrics = groupMetrics;
  } else if (selectedRevenue === "resource") {
    activeMetrics = resourceNames?.filter(name => name !== "ALL") || fallbackMetrics;
  } else {
    activeMetrics = revenueMetrics?.length ? revenueMetrics : fallbackMetrics;
  }



  useEffect(() => {

    if (isLoading) {
      setData([]);
      return;
    }

    if (!selectedResource) {
      setSelectedResource("ALL");
    }

    const allRevenueData: Resource[] = Array.isArray(revenueAsset?.RESOURCES) ? revenueAsset.RESOURCES : [];
    const allVolumeData: Resource[] = Array.isArray(VolumeDeltaAsset?.RESOURCES) ? VolumeDeltaAsset.RESOURCES : [];
    const allGroupedVolumeData: Resource[] = Array.isArray(groupedVolumeDataAsset?.RESOURCES)? groupedVolumeDataAsset.RESOURCES: [];
  
    
  const allGroupedPriceData: Resource[] = Array.isArray(groupedPricingAsset?.RESOURCES)? groupedPricingAsset.RESOURCES: [];
  
    const filterData = (data: Resource[], selectedResource: string, asset: any) => {
      if (selectedResource === "ALL") {
        return asset ? [asset] : [];
      }
      return data.filter(resource => resource.RESOURCE_NAME === selectedResource);
    };

    const revenueData = filterData(allRevenueData, selectedResource, revenueAsset);
    const volumeData = filterData(allVolumeData, selectedResource, VolumeDeltaAsset);
    const groupedPriceData = filterData(allGroupedPriceData,selectedResource,groupedPricingAsset)
    const groupedvolumeData = filterData(allGroupedVolumeData,selectedResource,groupedVolumeDataAsset)
    
    const processMetricData = (data: Resource[], metrics: string[]) => {
      return data.flatMap((resource) => {
        return metrics.flatMap((metric) => {
          const metricValues = resource[metric];
          if (!metricValues || typeof metricValues !== "object") return [];

          return Object.entries(metricValues).map(([time, value]) => ({
            time,
            metric,
            RESOURCE_NAME: selectedResource === "ALL" ? resource.RESOURCE_NAME : undefined,
            value: typeof value === "number" ? value : undefined
          }));
        });
      });
    };

    const revenueProcessed = processMetricData(revenueData, activeMetrics);
    const volumeProcessed = processMetricData(volumeData, activeMetrics);
    const groupedpriceprocessed = processMetricData(groupedPriceData,activeMetrics);
    const groupedvolumeprocessed = processMetricData(groupedvolumeData,activeMetrics);
   

    const mergedData: any[] = [];
    const dataMap: { [key: string]: { time: string; metric: string; RESOURCE_NAME: string; value?: number; delta?: number,volume?:number, price?:number } } = {};

    revenueProcessed.forEach((rev) => {
      const key = `${rev.time}-${rev.metric}-${rev.RESOURCE_NAME || "ALL"}`;
      dataMap[key] = {
        time: rev.time,
        metric: rev.metric,
        RESOURCE_NAME: rev.RESOURCE_NAME || "ALL",
        value: rev.value,
        delta: 0,
      };
    });
    groupedpriceprocessed.forEach((prc) => {
      const key = `${prc.time}-${prc.metric}-${prc.RESOURCE_NAME || "ALL"}`;
      if (dataMap[key]) {
        dataMap[key].price = prc.value;
      } else {
        dataMap[key] = {
          time: prc.time,
          metric: prc.metric,
          RESOURCE_NAME: prc.RESOURCE_NAME || "ALL",
          value: 0,
          delta: 0,
          price: prc.value,
        };
      }
    });

    groupedvolumeprocessed.forEach((vol) => {
      const key = `${vol.time}-${vol.metric}-${vol.RESOURCE_NAME || "ALL"}`;
      if (dataMap[key]) {
        dataMap[key].volume = vol.value;
      } else {
        dataMap[key] = {
          time: vol.time,
          metric: vol.metric,
          RESOURCE_NAME: vol.RESOURCE_NAME || "ALL",
          value: 0,
          delta: 0,
          volume: vol.value,
        };
      }
    });
 
    volumeProcessed.forEach((del) => {
      const key = `${del.time}-${del.metric}-${del.RESOURCE_NAME || "ALL"}`;
      if (dataMap[key]) {
        dataMap[key].delta = del.value;
      } else {
        dataMap[key] = {
          time: del.time,
          metric: del.metric,
          RESOURCE_NAME: del.RESOURCE_NAME || "ALL",
          value: 0,
          delta: del.value,
        };
      }
    });

    Object.values(dataMap).forEach((entry) => mergedData.push(entry));

    let groupedData: TableData[] = [];

    if (useIntervalAggregation) {
      const groupedDataMap: { [key: string]: TableData } = {};

      mergedData.forEach((entry) => {
        const dateObj = new Date(entry.time);
         const dt = DateTime.fromISO(entry.time, { setZone: true }); 
              
         const timeKey =
         !["day", "week", "month"].includes(selectedFrequency)
           ? dt.toFormat("hh:mm a")   
           : dt.toFormat("MM/dd/yyyy");  
       
      
        if (!groupedDataMap[timeKey]) {
          groupedDataMap[timeKey] = { hourEnding: timeKey, time: entry.time };
        }
      
        // Only sum if the value exists and is a number
        if (typeof entry.value === "number") {
          groupedDataMap[timeKey][entry.metric] = (groupedDataMap[timeKey][entry.metric] ?? 0) + entry.value;
        }
      
        if (typeof entry.delta === "number") {
          groupedDataMap[timeKey][`${entry.metric}_Delta`] = (groupedDataMap[timeKey][`${entry.metric}_Delta`] ?? 0) + entry.delta;
        }
      
        if (typeof entry.price === "number") {
          groupedDataMap[timeKey][`${entry.metric}_Price`] = (groupedDataMap[timeKey][`${entry.metric}_Price`] ?? 0) + entry.price;
        }
      
        if (typeof entry.volume === "number") {
          groupedDataMap[timeKey][`${entry.metric}_Volume`] = (groupedDataMap[timeKey][`${entry.metric}_Volume`] ?? 0) + entry.volume;
        }
      });
      
      groupedData = Object.values(groupedDataMap);
    } else {
      const groupedMap: Record<string, TableData> = {};

      mergedData.forEach((entry) => {
        const time = entry.time;

        if (!groupedMap[time]) {
          groupedMap[time] = {
            hourEnding: time,
            time: time,
          };
        }

        const metric = entry.metric;
        groupedMap[time][metric] = typeof entry.value === "number" ? entry.value : undefined;
        groupedMap[time][`${metric}_Delta`] = typeof entry.delta === "number" ? entry.delta : undefined;
        groupedMap[time][`${metric}_Price`] = typeof entry.price === "number" ? entry.price : undefined;
        groupedMap[time][`${metric}_Volume`] = typeof entry.volume === "number" ? entry.volume : undefined;
        
        
      });

      groupedData = Object.values(groupedMap);
    }

    setData(groupedData);
    let aggregatedData = Object.values(groupedData);
    const groupDataByInterval = (interval: number) => {
      const groupedData: TableData[] = [];

      aggregatedData.forEach((entry) => {
        const date = new Date(entry.time);
        const hour = date.getHours();
        const roundedMinutes = Math.floor(date.getMinutes() / interval) * interval;
        const timeKey = interval === 60 ? `${hour}:00` : `${hour}:${roundedMinutes}`;
        groupedData.push({
          hourEnding: timeKey,
          time: entry.time,
          ...Object.fromEntries(
            Object.keys(entry)
              .filter((key) => key !== "time" && key !== "RESOURCE_NAME")
              .map((metric) => [metric, entry[metric] !== undefined ? entry[metric] : undefined])
          ),
        });
      });

      return groupedData.sort((a, b) => new Date(a.time).getTime() - new Date(b.time).getTime());
    };

    if (useIntervalAggregation) {
      const minuteIntervals: { [key: string]: number } = {
        hour: 60,
        "15minute": 15,
        "5minute": 5,
      };

      const longIntervals: { [key: string]: number } = {
        day: 1440,
        week: 10080,
        month: 43200,
      };

      const isCustomDateRange = /^\d{4}-\d{2}-\d{2}\s*-\s*\d{4}-\d{2}-\d{2}$/.test(selectedDateRange);

      if (
        ["hour", "15minute", "5minute"].includes(selectedFrequency) && 
        (
          ["minus_7d", "yesterday", "mtd", "ytd", "minus_30d"].includes(selectedDateRange) || isCustomDateRange
        )
      ) {
        aggregatedData = groupDataByInterval(minuteIntervals[selectedFrequency]);
      } else if (
        ["day", "week", "month"].includes(selectedFrequency) &&
        (["ytd"].includes(selectedDateRange) || isCustomDateRange) 
      ) {
        aggregatedData = groupDataByInterval(longIntervals[selectedFrequency]);
      }
      
    }
    setData(useIntervalAggregation ? aggregatedData : groupedData);

  }, [
    revenueAsset, revenueMetrics, VolumeDeltaAsset, selectedResource, selectedFrequency, selectedDateRange, isLoading, useIntervalAggregation,groupedPricingAsset,groupedVolumeDataAsset
  ]);


  const [selectedRows, setSelectedRows] = useState<Set<number>>(new Set());


  const toggleRowSelection = (index: number) => {
    setSelectedRows((prevSelectedRows) => {
      const newSelectedRows = new Set(prevSelectedRows);
      if (newSelectedRows.has(index)) {
        newSelectedRows.delete(index);
      } else {
        newSelectedRows.add(index);
      }
      return newSelectedRows;
    });
  };
const formatTableValue = (value: any) => {
  // if (value === null || value === undefined) return "-";
  if (value === null || value === undefined) {
  return <span className="text-gray-400">-</span>;
}
  

  const num = Number(value);

  if (Number.isNaN(num)) return value;

  // convert 0 / 0.0 / -0 to dash
  // if (Object.is(num, -0) || num === 0) return "-";
  if (Object.is(num, -0) || num === 0) {
  return <span className="text-gray-400">-</span>;
}

  // negatives in financial format
  // if (num < 0) {
  //   return `(${Math.abs(num).toLocaleString(undefined, {
  //     maximumFractionDigits: 2,
  //   })})`;
  // }

  return num.toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
};
  const copySelectedRows = () => {
    const isAnyRowSelected = selectedRows.size > 0;
    const headers = [
      "S.no",
      "Hour Ending",
      ...activeMetrics.flatMap((metric) => [metric, `${metric} Delta`])
    ].join("\t");
    const dataToCopy = isAnyRowSelected
      ? Array.from(selectedRows).map((index) => data[index])
      : data;
    const formattedData = dataToCopy
      .map((row, index) => {
        const rowData = [
          index + 1,
          row.hourEnding,
          ...activeMetrics.flatMap((metric) => [
            row[metric] !== undefined ? row[metric].toFixed(2) : "-",
            row[`${metric}_Delta`] !== undefined ? row[`${metric}_Delta`].toFixed(2) : "-",
            row[`${metric}_Price`] !== undefined ? row[`${metric}_Price`].toFixed(2) : "-",
             row[`${metric}_Volume`] !== undefined ? row[`${metric}_Volume`].toFixed(2) : "-"
          ])
        ].join("\t");

        return rowData;
      })
      .join("\n");
    const finalClipboardText = `${headers}\n${formattedData}`;
    navigator.clipboard.writeText(finalClipboardText).then(() => {
    });
  };

  const { revenueData } = useAssetContext();
  const { logo } = useExportLogo();

  const formatDateTime = (isoString: string, selectedFrequency: string) => {
    
    const dt = DateTime.fromISO(isoString, { setZone: true });
  
    const isDateOnly = ["day", "week", "month"].includes(selectedFrequency);
  
    return isDateOnly
      ? dt.toFormat("MM/dd/yyyy  ")
      : dt.toFormat("MM/dd/yyyy hh:mm a "); 
  };
  
  const suffixMap: Record<string, string> = {
    "Estimated Settlements": "",       
    "Megawatt Delta": "_Delta",
    "Megawatts": "_Volume",
    "Price": "_Price"
  };

  return (
    <div>
  <div className="border-b border-gray-200 px-4 py-3">
  <div className="flex flex-col md:flex-row md:items-center md:justify-between">
    {/* Left (Title + Dropdown for small screen) */}
    <div className="flex flex-col flex-1">
      {/* Row 1: Title + Icons */}
      <div className="flex justify-between items-center">
        {title && (
          <h1 className="text-xs md:text-xl font-bold text-gray-600">
            {title}
          </h1>
        )}

        {/* Icons (right side in small, stay right in big) */}
        <div className="flex items-center gap-2 md:gap-3 lg:gap-3 md:hidden">
          <FaRegFilePdf
            className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
            title="Export as PDF"
            onClick={() =>
              exportTableToPDF(
                "table-container",
                "Estimated-Settlement",
                "Estimated DATA",
                revenueData,
                logo
              )
            }
          />
          <BsFiletypeCsv
            className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
            title="Export as CSV"
            onClick={() => exportToCSV(data, "exported_data")}
          />
          <TbFileExcel
            className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
            title="Export as Excel"
            onClick={() =>
             exportTableOldToExcel(
                "table-container",
                "Estimated Settlements Table",
                "Estimated Settlements",
                revenueData,
  logo,
                []
)
            }
          />
          <FaRegCopy
            className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
            title="Copy Data"
            onClick={copySelectedRows}
          />
        </div>
      </div>

      {/* Row 2: Dropdown (only visible in small) */}
      <div className="mt-2 md:hidden">
        <EstimatedRevenueDropdown />
      </div>
    </div>

    {/* Right side: Dropdown + Icons for big screen */}
    <div className="hidden md:flex items-center gap-3">
      <EstimatedRevenueDropdown />
      <FaRegFilePdf
        className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
        title="Export as PDF"
        onClick={() =>
          exportTableToPDF(
            "table-container",
            "Estimated-Settlement",
            "Estimated DATA",
            revenueData,
            logo
          )
        }
      />
      <BsFiletypeCsv
        className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
        title="Export as CSV"
        onClick={() => exportToCSV(data, "exported_data")}
      />
      <TbFileExcel
        className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
        title="Export as Excel"
        onClick={() =>
    exportTableOldToExcel(
            "table-container",
            "Estimated Settlements Table",
            "Estimated Settlements",
            revenueData,
  logo,
            []
)
        }
      />
      <FaRegCopy
        className="text-gray-500 hover:text-red-500 text-xl transform hover:scale-110 transition"
        title="Copy Data"
        onClick={copySelectedRows}
      />
    </div>
  </div>
</div>


     
<div
  className="
    overflow-x-auto font-poppins
    min-h-[50vh] sm:min-h-[60vh]
    max-h-[75vh] sm:max-h-[110vh] lg:max-h-[65vh]
  "
>
  <div id="table-container" className="w-full min-h-[65vh] relative">
        {(isLoading || isDeltaLoading) && (
    <div className="absolute inset-0 flex items-center justify-center bg-white bg-opacity-75 z-10">
      <div className="min-h-[200px] flex items-center justify-center">
        <WindmillLoading />
      </div>
    </div>
  )}
{apiError?.message && DeltaApiError?.message && (
  <ApiErrorMessage ApiError={{ message: 'Both Revenue and Delta APIs failed to load data.' }} />
)}


          <table className="min-w-full border-collapse border border-gray-300">
            <thead className="bg-gray-300 hover:bg-gray-300 transition-all duration-300 ease-in-out sticky top-0 z-10 truncate">
              <tr className="bg-[#E7E4FF] text-sm text-gray-600">
                {/* <th rowSpan={2} className="border border-gray-300 px-4 py-2 text-center">S.no</th> */}
                <th rowSpan={1} colSpan={1} className="border border-gray-300 px-4 py-2 text-center capitalize">{selectedRevenue}</th>
                {activeMetrics.map((metric, index) => (
                  <th key={index} colSpan={selectedMeasures.length} className="border border-gray-300 px-4 py-2 text-center">{metric}</th>
                ))}
              </tr>
              <tr className="bg-[#E7E4FF] text-sm text-gray-600">
                <th className="border border-gray-300 px-4 py-2 text-center">Hour Ending</th>
                {activeMetrics.flatMap((metric, index) =>
                  selectedMeasures.map((measure, measureIndex) => (
                    <th key={`${index}-${measureIndex}`} className="border border-gray-300 px-4 py-2 text-md font-normal">
                      {measure}
                    </th>
                  ))
                )}
              </tr>
            </thead>


            <tbody>
              {data.map((row, index) => (
                <tr
                  key={index}
                  className={`${selectedRows.has(index) ? 'bg-gray-300' : index % 2 === 0 ? 'bg-white' : 'bg-[#F9F9F9]'}`}
                  onClick={() => toggleRowSelection(index)}
                >
                  {/* <td className="text-center border border-gray-300 px-4 py-2">{index + 1}</td> */}
                  <td className="border border-gray-300 px-4 py-2 truncate"> {useIntervalAggregation ? row.hourEnding : formatDateTime(row.time, selectedFrequency)}
                  </td>
{activeMetrics.flatMap((metric) =>
  selectedMeasures.map((measure) => {
    const suffix = suffixMap[measure] ?? "";
    const key = `${metric}${suffix}`;
    const value = row[key];

    return (
      <td
        key={`${index}-${metric}-${measure}`}
        className="border border-gray-300 px-4 py-2 text-right "
      >
        {formatTableValue(value)}
      </td>
    );
  })
)}
                </tr>
              ))}
            </tbody>

          </table>
        </div>
      </div>
    </div>
  );
};

export default Table;